import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Flex from '../Flex';
import Spacing from '../Spacing';

const defaultProps = {
  hasError: false,
  children: null,
};

const propTypes = {
  hasError: PropTypes.bool,
  children: PropTypes.node,
};

const FormGroup = ({
  hasError,
  children,
}) => (
  <Spacing
    bottom={4}
    className={classnames(
      hasError && 'relative text-red-500',
    )}
  >
    <Flex direction="col">
      {children}
    </Flex>
  </Spacing>
);

FormGroup.defaultProps = defaultProps;
FormGroup.propTypes = propTypes;

export default FormGroup;
